import { createAction } from 'redux-actions';

const setFeatureFlags = createAction(
  '@platform/query/featureFlags/set',
  (payload: {
    sdgIntegration: boolean
  }) => payload,
);

export {
  setFeatureFlags,
};
